





































































import { Component, Vue } from 'vue-property-decorator'
import { Load } from '@/units'
import Form from '@/form'
import './style.less'

@Component
export default class Authen extends Vue {
  constructor () {
    super()

    console.info('📦 [Authen] componentDidMount....')
  }

  private form: any = new Form({
    username: '',
    password: '',
    logged: true
  })

  private touch (): void {
    this.$validator.validate()
      .then(async valid => {
        if (valid) {
          Load(this, true)

          const res: any = await this.$store.dispatch('APP.AUTH/login', this.form.data())
          if (res) {
            this.$router.push({ name: 'dash' })
          } else {
            alert('Username or Password is incorrect.')
          }

          Load(this, false)
        }
      })
  }
}
